import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { style: {"display":"flex","justify-content":"space-between","align-items":"center"} }, [
  /*#__PURE__*/_createElementVNode("span", null, "Conhecimento de Transporte")
], -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Cancelar", -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_8 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_9 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_12 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_13 = { class: "ant-row" }
const _hoisted_14 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_data = _resolveComponent("selecionar-data")!
  const _component_selecionar_pessoa = _resolveComponent("selecionar-pessoa")!
  const _component_selecionar_tipo_operacao = _resolveComponent("selecionar-tipo-operacao")!
  const _component_selecionar_cfop = _resolveComponent("selecionar-cfop")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_cte_abas = _resolveComponent("cte-abas")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_preview_pdf = _resolveComponent("preview-pdf")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      keyboard: false,
      centered: "",
      width: "70%",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
      "wrap-class-name": "ss-modal-pcp scroll-modal",
      maskClosable: false
    }, {
      title: _withCtx(() => [
        _hoisted_1
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createVNode(_component_a_tooltip, {
          placement: "top",
          title: "Imprimir"
        }, {
          default: _withCtx(() => [
            (_ctx.props.operacao.codigoRegistro > 0)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ant-btn ant-btn-lg ant-btn-secondary ss-botao-funcao",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imprimir && _ctx.imprimir(...args)))
                }, [
                  _createVNode(_component_icone, { nome: "imprimir" })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-secondary ss-btn-acao-destaque",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.modalBase.computedVisivel = false))
        }, _hoisted_3),
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.salvar()))
        }, _hoisted_5)
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          loading: _ctx.telaBase.carregando,
          paragraph: { rows: 15 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_a_form_item, {
                      label: "Chave de Acesso",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.state.conhecimentoTransporte.chaveAcesso,
                          "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.conhecimentoTransporte.chaveAcesso) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_a_form_item, {
                      label: "Número do Conhecimento",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_a_input, {
                          value: _ctx.state.conhecimentoTransporte.numeroCte,
                          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.conhecimentoTransporte.numeroCte) = $event))
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_a_form_item, {
                      label: "Data de Emissão",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_data, {
                          dataSelecionada: _ctx.state.conhecimentoTransporte.dataEmissao,
                          "onUpdate:dataSelecionada": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.conhecimentoTransporte.dataEmissao) = $event))
                        }, null, 8, ["dataSelecionada"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_a_form_item, {
                      label: "Transportadora",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_pessoa, {
                          codigoSelecionado: _ctx.state.conhecimentoTransporte.codigoPessoaTransportadora,
                          "onUpdate:codigoSelecionado": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.conhecimentoTransporte.codigoPessoaTransportadora) = $event)),
                          codigoRelacao: _ctx.state.conhecimentoTransporte.codigoTransportadora,
                          "onUpdate:codigoRelacao": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.conhecimentoTransporte.codigoTransportadora) = $event)),
                          preencherCodigoRelacao: true,
                          empresas: [_ctx.props.empresa],
                          tipoRelacao: _ctx.ETipoRelacaoPessoa.Transportadora,
                          disabled: _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar
                        }, null, 8, ["codigoSelecionado", "codigoRelacao", "empresas", "tipoRelacao", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_a_form_item, {
                      label: "Tomador",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_pessoa, {
                          codigoSelecionado: _ctx.state.conhecimentoTransporte.codigoTomador,
                          "onUpdate:codigoSelecionado": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.conhecimentoTransporte.codigoTomador) = $event)),
                          empresas: [_ctx.props.empresa],
                          disabled: _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar
                        }, null, 8, ["codigoSelecionado", "empresas", "disabled"])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_a_form_item, {
                      label: "Tipo de Operação",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_tipo_operacao, {
                          codigoSelecionado: _ctx.state.conhecimentoTransporte.codigoTipoOperacao,
                          "onUpdate:codigoSelecionado": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.conhecimentoTransporte.codigoTipoOperacao) = $event)),
                          tipoMovimento: _ctx.ETipoMovimentoComercial.Compras,
                          empresas: [_ctx.props.empresa],
                          disabled: _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar
                        }, null, 8, ["codigoSelecionado", "tipoMovimento", "empresas", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_a_form_item, {
                      label: "CFOP de Entrada",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_selecionar_cfop, {
                          filtrarApenasCfopsEntradas: true,
                          codigoSelecionado: _ctx.state.conhecimentoTransporte.cfopEntrada,
                          "onUpdate:codigoSelecionado": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.conhecimentoTransporte.cfopEntrada) = $event)),
                          disabled: _ctx.props.operacao.tipoPermissaoDados === _ctx.EPermissaoDados.Visualizar
                        }, null, 8, ["codigoSelecionado", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createVNode(_component_a_form_item, {
                      label: "Valor",
                      class: "ss-margin-campos"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_campo_numerico, {
                          valor: _ctx.state.conhecimentoTransporte.valorTotalPrestacao,
                          "onUpdate:valor": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.conhecimentoTransporte.valorTotalPrestacao) = $event)),
                          quantidadeCasasDecimais: 2,
                          fracionar: true
                        }, null, 8, ["valor"])
                      ]),
                      _: 1
                    })
                  ])
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_cte_abas, {
              documentos: _ctx.state.conhecimentoTransporte.documentosReferenciados,
              "onUpdate:documentos": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.conhecimentoTransporte.documentosReferenciados) = $event)),
              imposto: _ctx.state.conhecimentoTransporte.imposto,
              "onUpdate:imposto": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.conhecimentoTransporte.imposto) = $event)),
              detalhesPagamento: _ctx.state.conhecimentoTransporte.detalhesPagamento,
              "onUpdate:detalhesPagamento": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.conhecimentoTransporte.detalhesPagamento) = $event)),
              empresa: _ctx.props.empresa,
              valorFrete: _ctx.state.conhecimentoTransporte.valorTotalPrestacao,
              codigoTipoOperacao: _ctx.state.conhecimentoTransporte.codigoTipoOperacao,
              codigoPessoa: _ctx.state.conhecimentoTransporte.codigoTomador,
              editavel: _ctx.props.operacao.tipoPermissaoDados !== _ctx.EPermissaoDados.Visualizar
            }, null, 8, ["documentos", "imposto", "detalhesPagamento", "empresa", "valorFrete", "codigoTipoOperacao", "codigoPessoa", "editavel"])
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          apresentarBarraProgresso: _ctx.modalBase.apresentarBarraProgresso,
          fraseBarraProgresso: _ctx.modalBase.fraseBarraProgresso,
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "apresentarBarraProgresso", "fraseBarraProgresso", "retornoRequisicao"])
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_preview_pdf, {
      arquivos: _ctx.state.arquivosPdf
    }, null, 8, ["arquivos"])
  ]))
}